import { createContext } from 'react'

export const MenuKeyboardContext = createContext({
  registerMenuItem: () => () => {},
})
